/** @format */

export const actionTypes = {
  CLEAR_ERROR_MESSAGE: 'overlay/CLEAR_ERROR_MESSAGE',

  HANDLE_STATUS_SIDEBAR: 'overlay/HANDLE_STATUS_SIDEBAR',
  SET_STATUS_SIDEBAR_TRUE: 'overlay/SET_STATUS_SIDEBAR_TRUE',
  SET_STATUS_SIDEBAR_FALSE: 'overlay/SET_STATUS_SIDEBAR_FALSE',
}

export const clear = {
  errorMessages: () => ({
    type: actionTypes.CLEAR_ERROR_MESSAGE,
  }),
}
export const sidebar = {
  handleStatus: () => ({
    type: actionTypes.HANDLE_STATUS_SIDEBAR,
  }),
  setStatusTrue: () => ({
    type: actionTypes.SET_STATUS_SIDEBAR_TRUE,
  }),
  setStatusFalse: () => ({
    type: actionTypes.SET_STATUS_SIDEBAR_FALSE,
  }),
}
